/** Drop keys whose value is `undefined` (keeps `null`). */
export function omitUndefined<T extends object>(obj: T): T {
    return Object.fromEntries(
        Object.entries(obj).filter(([, v]) => v !== undefined),
    ) as T;
}
